/**
 * @desc 待处理信息提交（导出报关箱单）
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(tmsNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/dclExportDeclaration/${tmsNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
